export enum AdStatus {
  Undefined = 0,
  Active = 100,
  CompletedWithoutDeal = 200,
  CompletedWithDirectSale = 301,
  CompletedWithAuctionWin = 302,
  NotStarted = 900,
}
